var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"product-image",class:{'is-placeholder': _vm.src === _vm.defaultImage},attrs:{"src":_vm.src || _vm.defaultImage,"alt":"Faume"},on:{"error":function($event){_vm.src = _vm.defaultImage}}})
}
var staticRenderFns = []

export { render, staticRenderFns }